import { queryClient } from '../../main';

/**
 * B1 — invalidación tras reasignar o archivar un instructor, un nivel o una sala.
 *
 * Una reasignación reescribe eventos, plantillas y (en niveles) plazas y
 * recuperaciones de golpe, así que hay que tirar prácticamente toda la caché de
 * datos de negocio: dejar viva cualquiera de estas claves enseña al usuario datos
 * que ya no existen.
 *
 * Las claves van SIN tenantCode a propósito. `Configurations.tsx` declara sus
 * propias queries con claves sin tenant (`['niveles']`) mientras los hooks usan
 * `['niveles', tenantCode]`, así que conviven dos entradas por entidad; la forma
 * corta es un prefijo y alcanza a las dos.
 *
 * `tenant-branding` es imprescindible para las salas: EventForm y
 * PlantillasSemanales leen los desplegables de `branding.rooms`, no de
 * /classrooms.
 */
// `useTenantCode()` devuelve `string | null`, de ahí el null en la firma.
export const invalidateAfterReassign = (tenantCode?: string | null) => {
    [
        ['instructores'],
        ['niveles'],
        ['classrooms'],
        ['eventos'],
        ['eventos-date-range'],
        ['plazas'],
        ['plantillasSemanales'],
        ['client-portal'],
    ].forEach((queryKey) => queryClient.invalidateQueries({ queryKey }));

    if (tenantCode) {
        queryClient.invalidateQueries({ queryKey: ['tenant-branding', tenantCode] });
    }
};
